export default __webpack_public_path__ + "static/media/banner3.60e73e28.png";